import React, { createContext, useContext, useState, ReactNode } from 'react';
import { UserNameIdDto } from '../api/api-types';

interface EmployeeSelectionContextType {
  selectedEmployee: UserNameIdDto | null;
  setSelectedEmployee: (employee: UserNameIdDto | null) => void;
  clearSelectedEmployee: () => void;
}

const EmployeeSelectionContext = createContext<
  EmployeeSelectionContextType | undefined
>(undefined);

interface EmployeeSelectionProviderProps {
  children: ReactNode;
}

export const EmployeeSelectionProvider: React.FC<
  EmployeeSelectionProviderProps
> = ({ children }) => {
  const [selectedEmployee, setSelectedEmployee] =
    useState<UserNameIdDto | null>(null);

  const clearSelectedEmployee = () => {
    setSelectedEmployee(null);
  };

  return (
    <EmployeeSelectionContext.Provider
      value={{
        selectedEmployee,
        setSelectedEmployee,
        clearSelectedEmployee,
      }}
    >
      {children}
    </EmployeeSelectionContext.Provider>
  );
};

export const useEmployeeSelection = (): EmployeeSelectionContextType => {
  const context = useContext(EmployeeSelectionContext);
  if (!context) {
    throw new Error(
      'useEmployeeSelection must be used within an EmployeeSelectionProvider',
    );
  }
  return context;
};
